module.exports = __webpack_public_path__ + "img/curtain-left-desktop.c454e180.png";